import styled from "styled-components";

const DashboardWrapper = styled.div`
    padding: 25px 60px 25px;
    height: calc(100% - 60px);
`;

export default DashboardWrapper;